import { IEnvironment } from 'src/app/modules/shared/models/interfaces/environment.interface';
import * as baseEnv from 'src/environments/enviroment.base';

export const environment: IEnvironment = {
  ...baseEnv.environment,
  ...{
    CONFIGURATION: 'staging',
    API_URL: 'https://feature2-api.wetrack.com',
    Issuer: 'https://auth-feature2.wetrack.com',
    clientId: '592df680-28c8-4d23-98da-3c49307edc52',
    MOBILE_APP_ID: 'com.wetrack.stage1',
    DOMAIN: 'localhost:4200',
    CLUSTER_NAME:'WT-EMEA',
    mslConfig: {
      clientId: '592df680-28c8-4d23-98da-3c49307edc52',
      authority: 'https://gomocustomersdev.ciamlogin.com',
      redirectUri: '/' // change redirect url based on where u want to redirect after the authentication
      },
      datadogMonitoring: true,
      datadogService: 'wetrack-feature2-fe',
      datadogEnv: 'dev',
      google_maps: {
          ...baseEnv.environment.google_maps,
          key: 'AIzaSyCBs1wUM6MjPf9XfG3lDdn93RNBWKLC6qQ'
      }
  },
};
